export const digitValidatorRegExp = /\d/;
export const digitsValidatorRegExp = /^\d+$/;

export const validateDigit = (string: string): boolean => digitValidatorRegExp.test(string);
export const validateDigits = (string: string): boolean => digitsValidatorRegExp.test(string);
